/**
 * 購物車持久化快照：拿掉升級與套餐的全部可選明細，只留已選取的部分與比對、重建所需的值。
 *
 * 加入購物車時的商品物件帶著整份可選結構（全部升級、每個升級區塊的全部明細與口味樹），
 * 大型菜單單一品項可達數百 KB，購物車經 vuex-persist 寫入 localStorage 會撐爆 iOS 約 5 MB 的網域額度。
 *
 * 拿掉的欄位皆無讀取端：
 * - `upgradeList`：該餐點全部升級；編輯購物車時由最新菜單重建，比對與計價只讀 `upgradeSelect`。
 * - `upgradeSelect[].upgradeContentDetailList`：該升級區塊的全部明細；已選明細在 `upgradeContentDetails`。
 * - `comboSelect[].detailList`：該套餐區塊的全部明細；已選明細在 `details`。
 * - `comboList[].detailList`：同上；`comboList` 只用來判斷是否為套餐（詳情頁編輯還原的進入條件）。
 */

export function slimCartItem(item) {
	if (!item || typeof item !== 'object') return item
	const { upgradeList, ...rest } = item
	if (Array.isArray(item.upgradeSelect)) {
		rest.upgradeSelect = item.upgradeSelect.map(
			({ upgradeContentDetailList, ...content }) => content,
		)
	}
	if (Array.isArray(item.comboSelect)) {
		rest.comboSelect = item.comboSelect.map(
			({ detailList, ...content }) => content,
		)
	}
	if (Array.isArray(item.comboList)) {
		rest.comboList = item.comboList.map(({ detailList, ...content }) => content)
	}
	return rest
}

/**
 * @param {object} cart `{ [userId]: { [storeId]: 商品陣列 } }`
 */
export function slimCart(cart) {
	if (!cart || typeof cart !== 'object') return cart
	const result = {}
	Object.keys(cart).forEach(userId => {
		const stores = cart[userId]
		if (!stores || typeof stores !== 'object') {
			result[userId] = stores
			return
		}
		result[userId] = {}
		Object.keys(stores).forEach(storeId => {
			const items = stores[storeId]
			result[userId][storeId] = Array.isArray(items)
				? items.map(slimCartItem)
				: items
		})
	})
	return result
}

/**
 * 只瘦身 user 模組裡的 cart，其他欄位（登入、遊客身分、取餐資訊等）原樣保留。
 *
 * @param {object} persisted vuex-persist 存的整份物件（`{ user: {...} }`）
 */
export function slimPersistedState(persisted) {
	if (!persisted || typeof persisted !== 'object' || !persisted.user) {
		return persisted
	}
	return {
		...persisted,
		user: { ...persisted.user, cart: slimCart(persisted.user.cart) },
	}
}

/**
 * 舊 key 該留下的內容：清空購物車以釋放額度，其他欄位保留（退版時舊程式仍能沿用登入與遊客身分）。
 */
export function clearPersistedCart(persisted) {
	if (!persisted || typeof persisted !== 'object' || !persisted.user) {
		return persisted
	}
	return { ...persisted, user: { ...persisted.user, cart: { guest: {} } } }
}
